import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { forwardRef, useRef, useCallback, useImperativeHandle, useEffect } from 'react';
import classNames from 'classnames';
import { debounce } from 'lodash-es';
import ResizeObserver from 'resize-observer-polyfill';
import SmoothScrollbar from 'smooth-scrollbar';
import { prependPrefix } from '../../utils/style.js';

var _excluded = ["direction", "onScroll", "onReachStart", "onReachEnd", "useWindow", "scrollBehavior"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * WORKAROUND: 1. scrollTop 和 scrollLeft 返回值通常为整数类值，而高 DPI 屏幕（如 MacBook Retina），谷歌浏览器返回的像素为浮点数类型，
 *             且比实际值小 0.5px，导致无法达成 onReachEnd 的条件，所以使用 ceilScrollValue 对 scrollTop 和 scrollLeft 的值进
 *             行向上取整，保证实际值始终为整数类型。
 *             2. Android webview 中，可能由于计算误差等原因，触底时 scrollTop 可能有不到 1px 的偏差，所以使用向上取整修正偏差
 */

function ceilScrollValue(scrollValue) {
  return Math.ceil(scrollValue);
}

var DEFAULT_SMOOTH_SCROLL_DURATION = 200;
var Scrollable = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
      onScroll = _ref.onScroll,
      onReachStart = _ref.onReachStart,
      onReachEnd = _ref.onReachEnd,
      _ref$useWindow = _ref.useWindow,
      useWindow = _ref$useWindow === void 0 ? false : _ref$useWindow,
      _ref$scrollBehavior = _ref.scrollBehavior,
      scrollBehavior = _ref$scrollBehavior === void 0 ? 'auto' : _ref$scrollBehavior,
      props = _objectWithoutProperties(_ref, _excluded);

  var containerRef = useRef(null);
  var scrollElementRef = useRef();
  var smoothScrollbarRef = useRef(); // 用于记录旧滚动距离

  var scrollTop = useRef(0);
  var scrollLeft = useRef(0);
  /**
   * 获取可滚动的距离值
   */

  var getAvailableScrollDistance = useCallback(function () {
    if (!scrollElementRef.current) {
      return 0;
    }

    if (direction === 'vertical') {
      return scrollElementRef.current.scrollHeight - scrollElementRef.current.clientHeight;
    }

    return scrollElementRef.current.scrollWidth - scrollElementRef.current.clientWidth;
  }, [direction]);
  useImperativeHandle(ref, function () {
    return {
      getContainerElement: function getContainerElement() {
        return containerRef.current;
      },
      getScrollingElement: function getScrollingElement() {
        return scrollElementRef.current;
      },
      scrollToPos: function scrollToPos() {
        var percent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var options = arguments.length > 1 ? arguments[1] : undefined;

        if (!scrollElementRef.current) {
          return;
        }

        var pos = getAvailableScrollDistance() * percent; // 当 scrollBehavior 为 smooth 时，允许自定义动画时长或关闭动画

        var duration = scrollBehavior === 'smooth' && options !== null && options !== void 0 && options.behavior && options.behavior !== 'smooth' ? 0 : (options === null || options === void 0 ? void 0 : options.duration) || DEFAULT_SMOOTH_SCROLL_DURATION;

        if (direction === 'vertical') {
          if (scrollBehavior === 'smooth') {
            var _smoothScrollbarRef$c, _smoothScrollbarRef$c2;

            // 在滚动前重新计算滚动条状态，防止内容变化频繁时滚动位置不正确
            (_smoothScrollbarRef$c = smoothScrollbarRef.current) === null || _smoothScrollbarRef$c === void 0 ? void 0 : _smoothScrollbarRef$c.update();
            (_smoothScrollbarRef$c2 = smoothScrollbarRef.current) === null || _smoothScrollbarRef$c2 === void 0 ? void 0 : _smoothScrollbarRef$c2.scrollTo(0, pos, duration);
          } else {
            scrollElementRef.current.scrollTop = pos;
          }
        } else if (direction === 'horizontal') {
          if (scrollBehavior === 'smooth') {
            var _smoothScrollbarRef$c3, _smoothScrollbarRef$c4;

            (_smoothScrollbarRef$c3 = smoothScrollbarRef.current) === null || _smoothScrollbarRef$c3 === void 0 ? void 0 : _smoothScrollbarRef$c3.update();
            (_smoothScrollbarRef$c4 = smoothScrollbarRef.current) === null || _smoothScrollbarRef$c4 === void 0 ? void 0 : _smoothScrollbarRef$c4.scrollTo(pos, 0, duration);
          } else {
            scrollElementRef.current.scrollLeft = pos;
          }
        }
      }
    };
  });
  var handleScroll = useCallback(function () {
    if (!scrollElementRef.current) {
      return;
    }

    var elScrollTop = scrollElementRef.current.scrollTop;
    var elScrollLeft = scrollElementRef.current.scrollLeft;

    if (smoothScrollbarRef.current) {
      elScrollTop = smoothScrollbarRef.current.scrollTop;
      elScrollLeft = smoothScrollbarRef.current.scrollLeft;
    }

    var scrollPosition = ceilScrollValue(direction === 'vertical' ? elScrollTop : elScrollLeft) / getAvailableScrollDistance(); // 仅触发对应方向上的滚动事件

    if (direction === 'horizontal') {
      if (scrollPosition === scrollLeft.current) {
        return;
      }

      scrollLeft.current = scrollPosition;
    } else {
      if (scrollPosition === scrollTop.current) {
        return;
      }

      scrollTop.current = scrollPosition;
    }

    onScroll === null || onScroll === void 0 ? void 0 : onScroll(scrollPosition, scrollElementRef.current);

    if (scrollPosition === 0) {
      onReachStart === null || onReachStart === void 0 ? void 0 : onReachStart();
    } // WORKAROUND: Android webview 中滑动到底时 scrollTop 可能大于 scrollHeight - clientHeight，此时 scrollPosition 会大于 1


    if (scrollPosition >= 1) {
      onReachEnd === null || onReachEnd === void 0 ? void 0 : onReachEnd();
    }
  }, [direction, getAvailableScrollDistance, onReachEnd, onReachStart, onScroll]);
  useEffect(function () {
    if (useWindow) {
      scrollElementRef.current = document.documentElement;
      window.addEventListener('scroll', handleScroll);
      return function () {
        window.removeEventListener('scroll', handleScroll);
      };
    }

    if (containerRef.current) {
      scrollElementRef.current = containerRef.current;

      if (scrollBehavior === 'smooth') {
        smoothScrollbarRef.current = SmoothScrollbar.init(scrollElementRef.current, {
          // NOTICE: 原生滚动条对鼠标和触摸设备有不同的实现，如：
          //   - 使用触摸屏和触摸板滚动时带有动画衰减效果
          //   - 使用鼠标滚动时缺少动画衰减效果
          // 由于 smooth-scrollbar 在模拟滚动条时无法区分当前滚动由何种手段产生，
          // 若仅通过 `mobile.isMobile()` 区分的话会影响 iPad 等平板设备的触摸效果，故统一打开了动画衰减效果
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          damping: 0.1
        });
        smoothScrollbarRef.current.addListener(handleScroll);
        return function () {
          var _smoothScrollbarRef$c5;

          (_smoothScrollbarRef$c5 = smoothScrollbarRef.current) === null || _smoothScrollbarRef$c5 === void 0 ? void 0 : _smoothScrollbarRef$c5.removeListener(handleScroll);
        };
      }

      scrollElementRef.current.addEventListener('scroll', handleScroll);
      return function () {
        var _scrollElementRef$cur;

        (_scrollElementRef$cur = scrollElementRef.current) === null || _scrollElementRef$cur === void 0 ? void 0 : _scrollElementRef$cur.removeEventListener('scroll', handleScroll);
      };
    }

    return undefined;
  }, [scrollBehavior, useWindow, handleScroll]);
  useEffect(function () {
    if (scrollBehavior !== 'smooth' || !smoothScrollbarRef.current) {
      return undefined;
    }

    var debouncedUpdateScrollbar = debounce(function () {
      var _smoothScrollbarRef$c6;

      return (_smoothScrollbarRef$c6 = smoothScrollbarRef.current) === null || _smoothScrollbarRef$c6 === void 0 ? void 0 : _smoothScrollbarRef$c6.update();
    }, 100); // 容器尺寸变化后，重新计算滚动条

    var sizeObserver = new ResizeObserver(function (entries) {
      if (entries[0]) {
        debouncedUpdateScrollbar();
      }
    });
    sizeObserver.observe(smoothScrollbarRef.current.containerEl);
    return function () {
      var _smoothScrollbarRef$c7;

      sizeObserver.disconnect();
      (_smoothScrollbarRef$c7 = smoothScrollbarRef.current) === null || _smoothScrollbarRef$c7 === void 0 ? void 0 : _smoothScrollbarRef$c7.destroy();
    };
  }, [scrollBehavior]);
  var className = classNames(prependPrefix('scrollable'), prependPrefix('css-scrollbar'), prependPrefix(direction), props.className);

  if (scrollBehavior === 'smooth') {
    return /*#__PURE__*/React__default.createElement("div", _objectSpread(_objectSpread({}, props), {}, {
      ref: containerRef,
      className: className
    }), /*#__PURE__*/React__default.createElement("div", null, props.children));
  }

  return /*#__PURE__*/React__default.createElement("div", _objectSpread(_objectSpread({}, props), {}, {
    ref: containerRef,
    className: className
  }), props.children);
});

export { Scrollable };
